import { Calendar } from "primereact/calendar";
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import * as Fa from "react-icons/fa";
import { InputText } from "primereact/inputtext";
import { AutoComplete } from "primereact/autocomplete";
import { Dialog } from "primereact/dialog";
import InvoiceesData from "../Receipts/InvoiceesData";
import { createAPIReceiptsEndpoint, Endpoint } from "../../Services/Receipts/ReceiptsService";
import storage from "../../Services/Storage";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { createAPIEndpointMessage, EndpointMessage } from "../../Services/MessageService";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";

const PaymentDetails = () => {
    const [searchParams] = useSearchParams();
    let RcptHdrId = searchParams.get("RCVHID");
    const [partynamesugg, setPartynamesugg] = useState([]);
    const [partyname, setPartyname] = useState([]);
    const [onchangepartyname, setOnchangepartyname] = useState([]);
    const [branchCode, setBranchCode] = useState();
    const [branchName, setBranchName] = useState();
    const [saveLoader, setSaveLoader] = useState(false);
    const auth = storage.getLocal("user");
    const [partycode, setPartycode] = useState(null);
    const [selectedModeOfPayment, setSelectedModeOfPayment] = useState({
        "MASK_MOP_ID": "CHQ",
        "CODE": "CHQ",
        "DESCRIPTION": "(CHQ) Cheque"
    });
    const [modeofpayment, setModeofpayment] = useState([]);
    const [viewPaymentStatus, setViewPaymentStatus] = useState(false);
    const [showChkGrid, setShowChkGrid] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [paymentAccountsData, setPaymentAccountsData] = useState([]);
    const [voucherDate, setVoucherDate] = useState(new Date());
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [filteredAccounts, setFilteredAccounts] = useState([]);
    const [adjustedPopup, setAdjustedPopup] = useState(false);
    const [chequeNo, setChequeNo] = useState("");
    const [drawnOn, setDrawnOn] = useState();
    const [selectedDrawnOn, setSelectedDrawnOn] = useState(null);
    const [chequeDate, setChequeDate] = useState(new Date());
    const [paymentAmount, setPaymentAmount] = useState("");
    const [chequeGridData, setChequeGridData] = useState([]);
    const [documentGridData, setDocumentGridData] = useState([]);
    const [onCustSelectionData, setOnCustSelectionData] = useState();
    const [selectedDocumentData, setSelectedDocumentData] = useState([]);
    // const [documentData, setDocumentData] = useState();
    // const [paymentChqDetailData, setPaymentChqDetailData] = useState();
    // const [paymentDocDetailData, setPaymentDocDetailData] = useState();
    const [paymentBTDetailData, setPaymentBTDetailData] = useState([]);
    const [totalAmt, setTotalAmt] = useState("0.00");
    const [advance, setAdvance] = useState("0.00");
    const [adjusted, setAdjusted] = useState("0.00");
    const [totalDocAmt, setTotalDocAmt] = useState("0.00");
    const [viewAdvance, setViewAdvance] = useState("");
    const [viewTotamt, setviewTotamt] = useState("");
    const [viewadjustedNum, setViewadjustedNum] = useState("");
    const [viewTotalDocamt, setViewTotalDocamt] = useState("");
    const [viewVoucdt, setViewVoucdt] = useState("");
    const [viewMop, setViewMop] = useState("");
    // const [getPaymentDetailData, setGetPaymentDetailData] = useState();
    // const [cheqinhand, setCheqinhand] = useState("");
    const [paymentNumber, setPaymentNumber] = useState("");
    const [usedChequeNos, setUsedChequeNos] = useState([]);


    const statemodalProps = {totalAmt};
    const viewPaymentDetails = async (RcptHdrId) => {
        setSaveLoader(true);
        createAPIReceiptsEndpoint()
            .get(`${Endpoint.GetPaymentDetail}?PAYH_ID=${RcptHdrId}`)
            .then((response) => {
                console.log("GetReceiptDetail0000", response.data);
                if (response.data[0].RCVH_MODE_ID === "CHQ") {
                    // GetReceiptChqDetail(paymentNumber);
                }
                if (response.data[0].RCVH_MODE_ID === "PQR") {
                    // GetReceiptPQRDetailData(paymentNumber);
                }
                setPartycode(response.data[0].PARTY_CODE);
                // financialinformation(response.data[0].PARTY_ID);
                setOnchangepartyname(response.data[0].PARTY_NAME);
                setPaymentNumber(response.data[0].PAYH_NO);
                setViewMop(response.data[0].PAYH_MODE_ID);
                // setOtherdetls(response.data[0].RCVH_OTH_DETL);
                // console.log("response.data[0]", response.data[0].Column1);
                setViewVoucdt(response.data[0].RCVH_DATE);
                setViewAdvance(Number(response.data[0].ADV_AMT).toFixed(2));
                setviewTotamt(Number(response.data[0].TOTAL_AMT).toFixed(2));
                setViewadjustedNum("0.00");
                setViewTotalDocamt("0.00");
                setSaveLoader(false);
                // GetReceiptDocDetailsData();
            })
            .catch(() => {
                setSaveLoader(false);
            });
    };



    const getPaymentAccountsData = async (ModeCode, party) => {
        let strCurrId = "";
        if (partycode == "" || partycode == null) {
            if (party == "" || party == null) {
                strCurrId = "'";
            }
            else {
                strCurrId = "INR";
            }
        }
        else {
            strCurrId = "INR";
        }
        try {
            const res = await createAPIReceiptsEndpoint().get(`${Endpoint.PopulatePaymentAccountsData}?Mode=${ModeCode}&Voucher_Date=${voucherDate}&CurrId=${strCurrId}&CompId=${auth.CompId}`);
            console.log("res getPaymentAccountsData ", res);
            setPaymentAccountsData(res.data);
        } catch (error) {
            console.log("error ", error);
        }
    };
    const onSelectionChange = (e) => {
        setSelectedDocumentData(e.value);
        const total = e.value.reduce((acc, item) => {
            const amount = parseFloat(item.PAYABLE_AMOUNT) || 0;
            return acc + amount;
        }, 0);

        setTotalDocAmt(total.toFixed(2));

    };

    const getAdjustDocumentData = async () => {
        const formattedDate = new Intl.DateTimeFormat("en-GB").format(voucherDate);
        setSaveLoader(true);
        try {
            const res = await createAPIReceiptsEndpoint().get(`${Endpoint.PaymentAdjustDocument}?PartyId=${"13305815|000|INCS2709"}&VouDate=${formattedDate}&RcptMode=${selectedModeOfPayment?.CODE}`);
            setDocumentGridData(res.data.Table);
        } catch (error) {
            console.log("error ", error);
        }
        finally {
            setSaveLoader(false);
        }
    };

    const onSaveValidations = async () => {
        if (partycode == "" || partycode == null) {
            const res = await createAPIEndpointMessage().get(`${EndpointMessage.GetMessageByMsgIdSQL}?MsgId=VAL10123`);
            let resultString = res.data.replace("%1", "Party Name");
            toast.error(resultString, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return;
        }
        if (selectedModeOfPayment?.CODE == "" || selectedModeOfPayment?.CODE == null) {
            const res = await createAPIEndpointMessage().get(`${EndpointMessage.GetMessageByMsgIdSQL}?MsgId=VAL10123`);
            let resultString = res.data.replace("%1", "Mode");
            toast.error(resultString, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return;
        }
        if (selectedModeOfPayment?.CODE != "CHQ" && selectedModeOfPayment?.CODE != "BT" && selectedModeOfPayment?.CODE != "CASH") {
            const res = await createAPIEndpointMessage().get(`${EndpointMessage.GetMessageByMsgIdSQL}?MsgId=VAL10123`);
            let resultString = res.data.replace("%1", "Mode");
            toast.error(resultString, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return;
        }
        if (selectedModeOfPayment?.CODE == "CASH" || selectedModeOfPayment?.CODE == "BT") {
            console.log("from validation ", selectedAccount);
            if (selectedAccount?.BANK_NAME == "") {
                const res = await createAPIEndpointMessage().get(`${EndpointMessage.GetMessageByMsgIdSQL}?MsgId=VAL10123`);
                let resultString = res.data.replace("%1", "Account");
                toast.error(resultString, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                return;
            }

        }
        if (totalAmt <= 0) {
            const res = await createAPIEndpointMessage().get(`${EndpointMessage.GetMessageByMsgIdSQL}?MsgId=AMT0339`);
            toast.error(res.data, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return;
        }

    };
    const createPayload = () => {
        return {
            userID: auth.UserId,
            compId: auth.CompId,
            partyID: selectedSupplier ? selectedSupplier.MASK_PARTY_ID : "",
            mode: selectedModeOfPayment?.CODE,
            vouDate: new Intl.DateTimeFormat("en-GB").format(new Date(voucherDate)),
            account: selectedAccount?.MASK_BK_ACCT_NO,
            totalAmt: totalAmt ? totalAmt : "",
            adjAmt: adjusted ? adjusted : "",
            advAmt: advance ? advance : "",
            rcptNo: "",
            chqInHandAcct: "",//cheqinhand,
            othDtl: "",
            reptAcctId: selectedAccount?.MASK_ACCT_ID,
            branchId: "",
            objDocDetail: selectedDocumentData.map((row) => ({
                masK_DOCUMENT_ID: row.MASK_DOCUMENT_ID ? row.MASK_DOCUMENT_ID : "",
                documenT_NO: row.DOCUMENT_NO,
                documenT_DATE: row.DOCUMENT_DATE,
                documenT_AMOUNT: row.MASK_DOCUMENT_AMT.toString(),
                payable: row.PAYABLE_AMOUNT ? row.PAYABLE_AMOUNT.toString() : "0.0",
                amount: row.amount ? row.amount : "0.0",
                masK_DOCUMENT_TYPE: row.MASK_DOC_TYPE,
                masK_DOC_SR_NO: row.PAYTERM_SERIAL_NUMBAR,
                masK_EXCHANGE_RATE: row.MASK_EXCHANGE_RATE ? row.MASK_EXCHANGE_RATE.toString() : "0.0",
                masK_CN_AMT: row.MASK_CN_AMT ? row.MASK_CN_AMT.toString() : "0.0",
                masK_ACPR_ID: row.MASK_ACPR_ID ? row.MASK_ACPR_ID : "",
            })),
            objChqDetailGrid: chequeGridData?.map((row) => ({
                chequE_NUMBER: row?.chequeNo,
                chequE_DATE: new Intl.DateTimeFormat("en-GB").format(new Date(chequeDate)),
                drawN_ON: row?.drawnOn,
                accounT_NUMBER: row?.ACCOUNT_NUMBER,
                branch: branchName,
                paymenT_AMOUNT: row?.paymentAmount ? row?.paymentAmount.toString() : "0.0",
                advancE_AMOUNT: row?.paymentAmount ? row?.paymentAmount.toString() : "0.0",
                masK_BANK_RECO_TAG: row?.MASK_BANK_RECO_TAG,
                masK_ACCT_ID: branchCode
            })),
            objBTDetails: paymentBTDetailData?.map((row) => ({
                accounT_NO: row.ACCOUNT_NO ? row.ACCOUNT_NO : "0.0",
                transfeR_DATE: row.TRANSFER_DATE ? row.TRANSFER_DATE : "0.0",
                account: row.ACCOUNT_NO ? row.ACCOUNT_NO : "0.0",
                amount: row.AMOUNT ? row.AMOUNT : "0.0",
                advancE_AMOUNT: row.ADVANCE_AMOUNT ? row.ADVANCE_AMOUNT.toString() : "0.0",
                banK_NAME: row.BANK_NAME,
            })),
        };
    };

    const savePaymentDetails = async () => {
        // debugger;
        const isValid = onSaveValidations();
        const payload = createPayload();
        console.log("createPayload ", payload);
        if (isValid) {
            setSaveLoader(true);
            try {

                const res = await createAPIReceiptsEndpoint().post(`${Endpoint.SavePayment}`, payload);
                console.log("saved success", res);

                toast.success(res.data.Message, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                setPaymentNumber(res.data.PaymentNo);
                console.log("res ", res);
            } catch (error) {
                console.log("error ", error);
            }
            finally {
                setSaveLoader(false);
            }
        }
    };

    const getDetailGridData = async () => {
        if (selectedModeOfPayment?.CODE == "CHQ") {
            const res = await createAPIReceiptsEndpoint().get(`${Endpoint.GetPaymentChqDetail}?PAYH_ID=${"'"}&CompId=${auth.CompId}`);
            console.log("res.data GetPaymentChqDetail ", res.data);
            // setPaymentChqDetailData(res.data);
        }
        if (selectedModeOfPayment?.CODE == "BT") {
            const res = await createAPIReceiptsEndpoint().get(`${Endpoint.GetPaymentBTDetail}?strRCVHID=${""}`);
            setPaymentBTDetailData(res.data);

        }
    };

    const getPaymentDocDetailData = async () => {
        const paymentId = RcptHdrId ? RcptHdrId : "";
        try {
            const res = await createAPIReceiptsEndpoint().get(`${Endpoint.GetPaymentDocDetail}?PAYH_ID=${paymentId}&CompId=${auth.CompId}`);
            // setPaymentDocDetailData(res.data);
            console.log("res res ", res.data);


        } catch (err) {
            console.log("error ", err);
        }
        // if (selectedModeOfPayment?.CODE == "CASH" || selectedModeOfPayment?.CODE == "BT") {
        //     getPaymentAccountsData();
        // }
    };

    const formatChequeDate = (rowData) => {
        const date = new Date(rowData.chequeDate);

        const day = String(date.getDate()).padStart(2, "0");       // 2-digit day
        const month = String(date.getMonth() + 1).padStart(2, "0"); // 2-digit month (0-based index)
        const year = date.getFullYear();

        return `${month}/${day}/${year}`; // MM/DD/YYYY
    };

    const populateAllData = () => {
        createAPIReceiptsEndpoint()
            .get(`${Endpoint.PopulateCustomer}?CompId=${auth.CompId}`)
            .then((response) => {
                setPartynamesugg(response.data);
            })
            .catch((err) => {
                console.log("error ", err);
            });
        createAPIReceiptsEndpoint()
            .get(`${Endpoint.PopulateMOPData}`)
            .then((response) => {
                console.log("mop", response.data);
                setModeofpayment(response.data);
                setSelectedModeOfPayment(response.data[1]);
                setSaveLoader(false);
            })
            .catch(() => {
                setSaveLoader(false);
            });
    };


    const handleClickYes = () => {
        if (chequeNo == "" || chequeNo == null) {
            toast.warn("Please Enter  Cheque Number", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return false;
        }
        if (usedChequeNos.includes(chequeNo)) {
            toast.warn("Cheque number already used. Please enter a new one.", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return false;
        }
        if (selectedDrawnOn.BANK_NAME == "" || selectedDrawnOn.BANK_NAME == null) {
            toast.warn("Please Enter Bank Name", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return false;
        }
        if (paymentAmount == "" || paymentAmount == null) {
            toast.warn("Please Enter Payment Amount", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return false;
        }

        const newChequeData = {
            rowNo: chequeGridData.length + 1,
            chequeNo: chequeNo,
            drawnOn: selectedDrawnOn.BANK_NAME,
            chequeDate: chequeDate,
            paymentAmount: paymentAmount,
        };
        const currentTotal = parseFloat(totalAmt) || 0;
        const newPayment = parseFloat(paymentAmount) || 0;
        // Add new payment to total amount
        const updatedTotal = currentTotal + newPayment;

        // Update state
        setTotalAmt(updatedTotal.toFixed(2));
        setAdvance(updatedTotal.toFixed(2));
        setUsedChequeNos([...usedChequeNos, chequeNo]);
        setChequeGridData([...chequeGridData, newChequeData]);

        setShowPopup(false);
    };

    // const ChkOnPayMode = async () => {
      
    //     // if (partycode == "" || partycode == null) {
    //     //     const res = await createAPIEndpointMessage().get(`${EndpointMessage.GetMessageByMsgIdSQL}?MsgId=VAL10123`);
    //     //     let resultString = res.data.replace("%1", "Party Name");
    //     //     toast.error(resultString, {
    //     //         position: toast.POSITION.TOP_CENTER,
    //     //         pauseOnFocusLoss: false,
    //     //         closeButton: false,
    //     //         autoClose: 3000,
    //     //     });
    //     //     return false;
    //     // }
    //     // if (selectedModeOfPayment?.CODE == "CASH") {
    //     //     if (Number(totalAmt) <= 0) {
    //     //         const res = await createAPIEndpointMessage().get(`${EndpointMessage.GetMessageByMsgIdSQL}?MsgId=AMT0087`);
    //     //         toast.error(res.data, {
    //     //             position: toast.POSITION.TOP_CENTER,
    //     //             pauseOnFocusLoss: false,
    //     //             closeButton: false,
    //     //             autoClose: 3000,
    //     //         });
    //     //         return false;

    //     //     }
    //     // } else {
    //     //     if (selectedModeOfPayment?.CODE == "BT") {


    //     //     }
    //     //     else {

    //     //         if (selectedModeOfPayment?.CODE == "CHQ") {
    //     //             if (documentGridData.length < 1) {
    //     //                 const res = await createAPIEndpointMessage().get(`${EndpointMessage.GetMessageByMsgIdSQL}?MsgId=VAL9643`);
    //     //                 toast.error(res.data, {
    //     //                     position: toast.POSITION.TOP_CENTER,
    //     //                     pauseOnFocusLoss: false,
    //     //                     closeButton: false,
    //     //                     autoClose: 3000,
    //     //                 });
    //     //                 return false;
    //     //             }
    //     //         }

    //     //     }

    //     // }
    //     return true;
    // };



    const adjustDocument = () => {
        // debugger;
        const paymentCode = selectedModeOfPayment?.CODE;
        const amount = Number(totalAmt);

        console.log("Payment Code:", paymentCode);
        console.log("Amount:", amount);

        if (paymentCode === "CHQ" && (isNaN(amount) || amount === 0)) {
            toast.warn("Please Add Cheque First", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            // }
            return;
        }

        if (partycode == "" || partycode == null) {
            toast.warn("Please Enter  Customer Name", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return false;
        }
        if (selectedModeOfPayment?.CODE === "CASH") {
            if (!totalAmt || totalAmt <= 0) {

                toast.warn("Total Amount Can't be Null", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                return false;

            }
            else if (!selectedAccount || selectedAccount === "") {

                toast.warn("Please Select Account Name", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                return false;

            }
        }
        getAdjustDocumentData();
        setAdjustedPopup(true);

    };
    const handleOkReceivable = () => {
        setAdjustedPopup(false);
        // setDocumentData(selectedDocumentData);
    };

    const onCustomerSelected = async () => {
        try {
            const res = await createAPIReceiptsEndpoint().get(`${Endpoint.OnCustomerSelected}?Party_Id=${partycode}&CompId=${auth.CompId}`);
            // const res = await createAPIReceiptsEndpoint().get(`${Endpoint.OnCustomerSelected}?Party_Id=${"91425414|000|01484"}&CompId=${"13305785"}`);
            setOnCustSelectionData(res.data);
            getPaymentDocDetailData();
            getDetailGridData();
            console.log("cust ", onCustSelectionData);

        } catch (error) {
            console.log("error ", error);
        }

    };
    const onAmountChange = (val, rowData) => {
        const updatedData = selectedDocumentData.map((item) => {
            if (item.DOCUMENT_NO === rowData.DOCUMENT_NO) {
                return { ...item, amount: val };
            }
            return item;
        });
        setSelectedDocumentData(updatedData);
        console.log("selectedDocumentData ", selectedDocumentData);
        calculateAdjustedAndAdvance(updatedData);
    };

    const calculateAdjustedAndAdvance = (data) => {
        const adjustedSum = data.reduce((acc, curr) => {
            const amt = curr.amount || "0";
            return (parseFloat(acc) + parseFloat(amt)).toString(); // Keep result as string
        }, "0");

        setAdjusted(adjustedSum); // adjusted as string

        const advanceAmt = (parseFloat(totalAmt || "0") - parseFloat(adjustedSum)).toString();
        setAdvance(advanceAmt); // also a string
    };


    useEffect(() => {
        console.log("Updated selectedDocumentData: ", selectedDocumentData?.PAYABLE_AMOUNT);
    }, [selectedDocumentData]);



    // Ensure data is always an array
    const searchEmployee = (e) => {
        // const query = e?.query?.trim().toLowerCase() || "";
        setTimeout(() => {
            let _filteredemployee;

            if (!e.query.trim().length) {
                _filteredemployee = [...partynamesugg];
            } else {
                _filteredemployee = partynamesugg.filter((employee) => {
                    return (
                        employee.SUPPLIER_CODE.toLowerCase().includes(e.query.toLowerCase()) ||
                        employee.SUPPLIER_NAME.toLowerCase().includes(e.query.toLowerCase())
                    );

                });
            }

            setPartyname(_filteredemployee);
        }, 250);
    };


    const employeeTemplate = (employee) => {
        return (
            <>
                {employee.SUPPLIER_CODE} - {employee.SUPPLIER_NAME}
            </>
        );
    };

    const handleAccountChange = (e) => {
        setSelectedAccount(e.value);
    };

    const searchAccount = (event) => {
        const query = event?.query?.toLowerCase();
        const filtered = paymentAccountsData?.filter(account =>
            account.BANK_NAME.toLowerCase().includes(query)
        );
        setFilteredAccounts(filtered);
    };
    const handleChange = async (e) => {
        setOnchangepartyname(e.target.value);
        setSelectedSupplier(e.target.value);

        setPartycode(e.target.value.SUPPLIER_CODE);
        console.log("supp ", selectedSupplier);

        setSaveLoader(true);
        // await createAPIReceiptsEndpoint()
        //     .get(
        //         `${Endpoint.GetCustFinancialInfo}?Party_Id=${e.target.value.SUPPLIER_CODE}&CompId=${auth.CompId}`
        //     )
        //     .then((response) => {
        // //         console.log("calling ", "TYPEOF ", typeof (response.data), (Number(response.data.Closingbal)).toFixed(2));
        // //         console.log("response from handle change ", response.data);
        //         setClosebalance((Number(response.data.Closingbal)).toFixed(2));
        // //         setCheqinhand(Number(response.data.ChqsInhand).toFixed(2));
        // //         setNetbalance(Number(response.data.NetBal).toFixed(2));
        // //         setAdvancerecpt(Number(response.data.AvailableCreditlimit).toFixed(2));
        setSaveLoader(false);
        //         // setModeofpayment(response.data);
        //         // debugger;
        if (selectedModeOfPayment != null || selectedModeOfPayment != undefined) {
            if (selectedModeOfPayment?.CODE === "CASH" || selectedModeOfPayment?.CODE === "BT") {
                getPaymentAccountsData(selectedModeOfPayment?.CODE, e.target.value.SUPPLIER_CODE);

            }
        }
        // })
        // .catch(() => { setSaveLoader(false); });
    };


    const paymentBtDetail = async () => {
        try {
            const res = await createAPIReceiptsEndpoint().get(`${Endpoint.GetPaymentBTDetail}?strRCVHID=${""}`);
            setPaymentBTDetailData(res.data);

        } catch (error) {
            console.log("error ", error);
        }
    };

    const handleModeChange = (e) => {

        setSelectedModeOfPayment(e.value);
        console.log(e.value, "Mode");
        getPaymentAccountsData(e.value?.CODE, "");
    };
    const handleCancel = () => {
        setShowPopup(true);
        createAPIReceiptsEndpoint().post(`${Endpoint.CheckBeforeDelete}?RcptHdrId=${RcptHdrId}`).then(() => {

        }).catch((err) => {
            console.log("error ", err);
        });
    };

    const addCheque = async () => {
        if (partycode == "" || partycode == null) {
            const res = await createAPIEndpointMessage().get(`${EndpointMessage.GetMessageByMsgIdSQL}?MsgId=VAL10123`);
            let resultString = res.data.replace("%1", "Party Name");
            toast.warn(resultString, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return;
        }
        if (selectedModeOfPayment?.CODE == "" || selectedModeOfPayment?.CODE == null) {
            const res = await createAPIEndpointMessage().get(`${EndpointMessage.GetMessageByMsgIdSQL}?MsgId=VAL10123`);
            let resultString = res.data.replace("%1", "Mode");
            toast.warn(resultString, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return;
        }


        let strCurrId = "";
        if (partycode == "" || partycode == null) {
            strCurrId = "";
        }
        else {
            strCurrId = "INR";
        }
        try {
            const formattedDate = new Intl.DateTimeFormat("en-GB").format(voucherDate);
            console.log("formattedDateformattedDate ", formattedDate);

            const res = await createAPIReceiptsEndpoint().get(`${Endpoint.PopulatePaymentAccountsData}?Mode=${"BT"}&Voucher_Date=${formattedDate}&CurrId=${strCurrId}&CompId=${auth.CompId}`);
            setDrawnOn(res.data);
            if (res.data && res.data.length > 0) {
                const firstBank = res.data[0];

                // const maskAcctId = firstBank.MASK_ACCT_ID?.split('|')[0]; 
                setSelectedDrawnOn(res.data[0].BANK_NAME);
                setBranchCode(firstBank.MASK_ACCT_ID);
                setBranchName(firstBank.MASK_BRANCH_NAME);
            }
            setShowPopup(true);
            // setPaymentAmount(e.target.value);
        } catch (error) {
            console.log("error ", error);
        }
    };
    const onDrawnOnChange = (e) => {
        console.log("eselcted value", e.value.BANK_NAME, selectedDrawnOn);
        setSelectedDrawnOn(e.value);
        console.log("selectedDrawnOnselectedDrawnOn ", selectedDrawnOn);
    };

    const getPaymentDetail = async () => {
        try {
            const res = await createAPIReceiptsEndpoint().get(`${Endpoint.GetPaymentDetail}?PAYH_ID=${RcptHdrId}`);
            console.log("res res res res", res.data);
            // setGetPaymentDetailData(res.data);
            setPartycode(res.data[0]?.PARTY_CODE);
            if (res.data[0]?.PAYH_MODE_ID == "CHQ") {
                setSelectedModeOfPayment(modeofpayment[2]);
            } if (res.data[0]?.PAYH_MODE_ID == "PQR") {
                setSelectedModeOfPayment(modeofpayment[3]);
            } else {
                setSelectedModeOfPayment(modeofpayment[0]);
            }
            setTotalAmt(res.data[0]?.TOTAL_AMT);
            setAdvance(res.data[0]?.ADV_AMT);
            setOnchangepartyname(res.data[0]?.PARTY_NAME);



        } catch (error) {
            console.log("error ", error);
        }
    };
    // function isValidDate(dateString) {
    //     const date = new Date(dateString);
    //     return !isNaN(date.getTime());
    // }

    // function formatVoucherDate(dateString) {
    //     if (isValidDate(dateString)) {
    //         const date = new Date(dateString);
    //         return new Intl.DateTimeFormat("en-GB").format(date);
    //     } else {
    //         console.error("Invalid date value:", dateString);
    //         return "";
    //     }
    // }
    const handleRemoveRow = (rowData) => {
        const newData = selectedDocumentData.filter(
            (item) => item.DOCUMENT_NO !== rowData.DOCUMENT_NO
        );
        // advance = totalamt;
        setSelectedDocumentData(newData);
    };
    const handleRemoveChequeRow = (rowData) => {
        const newData = chequeGridData.filter(
            (item) => item.DOCUMENT_NO !== rowData.DOCUMENT_NO
        );
        // advance = totalamt;
        setChequeGridData(newData);
    };

    const renderAction = (rowData) => {
        return (
            <>
                <div className="action-icon">
                    <div
                        className="d-inline"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Cancel"
                    >
                        <button
                            className="grid-icon"
                            onClick={() => {
                                handleRemoveRow(rowData);
                            }}
                        >
                            <Fa.FaTimes className="cancel" />
                        </button>
                    </div>
                </div>
            </>
        );
    };
    const renderChequeAction = (rowData) => {
        return (
            <>
                <div className="action-icon">
                    <div
                        className="d-inline"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Cancel"
                    >
                        <button
                            className="grid-icon"
                            onClick={() => {
                                handleRemoveChequeRow(rowData);
                            }}
                        >
                            <Fa.FaTimes className="cancel" />
                        </button>
                    </div>
                </div>
            </>
        );
    };

    useEffect(() => {
        if (RcptHdrId != null) {
            setViewPaymentStatus(true);
            viewPaymentDetails(RcptHdrId);
        }
    }, []);

    useEffect(() => {
        if (selectedModeOfPayment?.CODE == "CHQ") {
            setShowChkGrid(true);
        } else {
            setShowChkGrid(false);
        }

    }, [selectedModeOfPayment]);

    useEffect(() => {

        if (partycode != null) {
            onCustomerSelected();
        }
    }, [partycode]);

    useEffect(() => {

        if (selectedModeOfPayment?.CODE == "CHQ" || selectedModeOfPayment?.CODE == "BT") {
            paymentBtDetail();
        }
        getDetailGridData();
    }, [selectedModeOfPayment]);

    useEffect(() => {
        setAdjusted("");
        populateAllData();
        getPaymentDetail();
        setViewPaymentStatus(false);
    }, []);

    return (
        <> {
            saveLoader ? <Loader /> :
                <div>
                    <div className="col-12 pt-0 pb-4">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb mx-1">
                                        <li className="breadcrumb-item">
                                            <Link to="/creditmanagement/payments">Payments</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">Details</li>
                                    </ol>
                                </nav>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="float-end">
                                    <Link to="/creditmanagement/payments">
                                        <button type="button" className="btn btn-outline-primary me-3">
                                            <Fa.FaLongArrowAltLeft className="backIcon" /> Back to All Records
                                        </button>
                                    </Link>
                                    {viewPaymentStatus && (
                                        <button type="button" className="btn btn-cancel-red me-3" onClick={() => handleCancel}>Cancel</button>
                                    )}
                                    {!viewPaymentStatus && (
                                        <button type="button" className="btn btn-primary" onClick={savePaymentDetails}>Save</button>
                                    )}
                                </div>
                            </div>
                        </div>
                        <section className="sales-box">
                            <form>
                                <div className="row">
                                    {/* <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                <label className="form-label">
                                    Closing Balance <span className="mandatory">*</span>
                                </label>
                                <InputText
                                    id="closebal"
                                    name="closebal"
                                    value={closebalance}
                                    className={"form-control"}
                                    disabled
                                />
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                <label className="form-label">
                                    Cheques in Hand <span className="mandatory">*</span>
                                </label>
                                <InputText
                                    id="chqhand"
                                    name="chqhand"
                                    value={cheqinhand}
                                    className={"form-control"}
                                    disabled
                                />
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                <label className="form-label">
                                    Net Balance <span className="mandatory">*</span>
                                </label>
                                <InputText
                                    id="netbal"
                                    name="netbal"
                                    value={netbalance}
                                    className={"form-control"}
                                    disabled
                                />
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                <label className="form-label">
                                    Advance Receipt <span className="mandatory">*</span>
                                </label>
                                <InputText
                                    id="advrecpt"
                                    name="advrecpt"
                                    value={advancerecpt}
                                    className={"form-control"}
                                    disabled
                                />
                            </div> */}
                                    <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                        <label className="form-label">
                                            Customer Code <span className="mandatory">*</span>
                                        </label>
                                        <InputText
                                            id="partycode"
                                            name="partycode"
                                            value={partycode}
                                            className={"form-control"}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                                        <label className="form-label">
                                            Customer Name <span className="mandatory">*</span>
                                        </label>
                                        <div className="d-block">
                                            <AutoComplete
                                                field="SUPPLIER_NAME"
                                                value={onchangepartyname}
                                                suggestions={partyname}
                                                completeMethod={searchEmployee}
                                                onChange={(e) => {
                                                    handleChange(e);
                                                }}
                                                dropdown={true}
                                                itemTemplate={employeeTemplate}
                                                emptyMessage="No Customer Name found."
                                                showEmptyMessage
                                                disabled={viewPaymentStatus}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                        <label className="form-label">
                                            Payment No. <span className="mandatory">*</span>
                                        </label>
                                        <InputText
                                            id="partyID"
                                            name="partyID"
                                            value={paymentNumber}
                                            className={"form-control"}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                        <label className="form-label">
                                            Voucher Date <span className="mandatory">*</span>
                                        </label>
                                        {!viewPaymentStatus && (
                                            <Calendar
                                                id="chequeDate"
                                                value={voucherDate || new Date()}
                                                onChange={(e) => setVoucherDate(e.value)}
                                                // dateFormat="mm/dd/yy"
                                                showIcon
                                                maxDate={new Date()}
                                            />
                                        )}
                                        {viewPaymentStatus && (
                                            <InputText
                                                clasclassName="form-control"
                                                type="text"
                                                value={viewVoucdt}
                                                // value=""
                                                disabled
                                            />
                                        )}
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                        <label className="form-label">
                                            Mode <span className="mandatory">*</span>
                                        </label>
                                        {!viewPaymentStatus && (
                                            <Dropdown
                                                inputId="payment_mode"
                                                name="payment_mode"
                                                value={selectedModeOfPayment}
                                                options={modeofpayment}
                                                optionLabel="DESCRIPTION"
                                                // placeholder="Select"
                                                // className={classNames({
                                                //     "p-invalid": isFormFieldInvalid("payment_mode"),
                                                // })}
                                                onChange={(e) => {
                                                    handleModeChange(e);
                                                }}
                                            // disabled={
                                            //     selectedInvoicesData.length > 0
                                            //         ? true
                                            //         : false || viewPaymentStatus
                                            // }
                                            />
                                        )}
                                        {viewPaymentStatus && (
                                            <InputText
                                                clasclassName="form-control"
                                                type="text"
                                                value={viewMop}
                                                // value=""
                                                disabled
                                            />
                                        )}
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                        <label className="form-label">Other Details</label>
                                        <InputText
                                            id="closebal"
                                            name="closebal"
                                            // value={otherdetls}
                                            className={"form-control"}
                                            // onChange={handleotherDetails}
                                            disabled={viewPaymentStatus}
                                        />
                                    </div>

                                    <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                        <label className="form-label">
                                            Account <span className="mandatory">*</span>
                                        </label>
                                        <AutoComplete
                                            field="BANK_NAME"
                                            value={selectedAccount}
                                            suggestions={filteredAccounts}
                                            completeMethod={searchAccount}
                                            onChange={handleAccountChange}
                                            dropdown={true}
                                            itemTemplate={(account) => <div>{account.BANK_NAME}</div>}
                                            emptyMessage={selectedModeOfPayment?.CODE === "CASH" ? "Please Select Customer Name" : "No Account found."}
                                            showEmptyMessage={true}
                                            disabled={

                                                !(selectedModeOfPayment?.CODE === "CASH" ||
                                                    selectedModeOfPayment?.CODE === "BT" || viewPaymentStatus)
                                            }
                                        />
                                    </div>

                                    <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                        <label className="form-label">Advance</label>
                                        <InputText
                                            id="closebal"
                                            name="closebal"
                                            // value={advance}
                                            value={
                                                viewPaymentStatus ? viewAdvance : advance
                                            }
                                            className={"form-control"}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                        <label className="form-label">
                                            Total Amount <span className="mandatory">*</span>
                                        </label>
                                        <InputText
                                            id="closebal"
                                            name="closebal"

                                            value={viewPaymentStatus ? viewTotamt : totalAmt}
                                            className={"form-control"}
                                            onChange={(e) => {
                                                setTotalAmt(e.target.value);
                                                setAdvance(e.target.value); // update advance too

                                            }}
                                            // disabled={
                                            //     cashModeOn || selectedInvoicesData.length > 0
                                            //         ? true
                                            //         : false || viewPaymentStatus
                                            // }
                                            disabled={(selectedModeOfPayment?.CODE === "CHQ")}
                                        />
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                        <label className="form-label">Adjusted</label>
                                        <InputText
                                            id="closebal"
                                            name="closebal"
                                            // value={adjusted}
                                            value={viewPaymentStatus ? viewadjustedNum : adjusted}
                                            className={"form-control"}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                        <label className="form-label">Total Document Amount</label>
                                        <InputText
                                            id="closebal"
                                            name="closebal"

                                            value={viewPaymentStatus ? viewTotalDocamt : totalDocAmt}
                                            className={"form-control"}
                                            disabled
                                        />
                                    </div>

                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <div className="float-end mt-2">
                                            {showChkGrid && (
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary me-3"
                                                    onClick={() => {
                                                        addCheque();
                                                    }}
                                                >
                                                    Add Cheque
                                                </button>
                                            )}
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={() => {
                                                    adjustDocument();
                                                }}
                                            >
                                                Adjust Document
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </section>

                        {!viewPaymentStatus && (
                            <section className="DataTable">
                                <DataTable
                                    value={selectedDocumentData}
                                    paginator
                                    rows={10}
                                    // filterDisplay="row"
                                    // showGridlines
                                    stripedRows
                                    scrollHeight="80vh"
                                    emptyMessage="No Invoice found."
                                    tableStyle={{ minWidth: "60rem" }}
                                    editable={true}
                                    editMode="row"
                                >
                                    <Column
                                        field="DOCUMENT_NO"
                                        header="Document Number"
                                        style={{ minWidth: "8rem" }}
                                    ></Column>
                                    <Column
                                        field="DOCUMENT_DATE"
                                        header="Document Date"
                                        style={{ minWidth: "12rem" }}
                                    ></Column>
                                    <Column
                                        field="MASK_DOCUMENT_AMT"
                                        header="Document Amount "
                                        style={{ minWidth: "12rem" }}
                                    ></Column>
                                    <Column
                                        field="PAYABLE_AMOUNT"
                                        header="Payable"
                                        style={{ minWidth: "12rem" }}
                                    ></Column>
                                    {/* <Column field="amount" header="Amount"><InputText/></Column> */}
                                    <Column
                                        field="amount"
                                        header="Amount"
                                        body={(rowData) => (
                                            <InputText
                                                value={rowData.amount}
                                                onChange={(e) => {
                                                    const inputValue = e.target.value;
                                                    const regex = /^(?!0\d)\d+(\.\d{0,2})?$/;
                                                    if (regex.test(inputValue) || inputValue === "") {
                                                        onAmountChange(inputValue, rowData);
                                                    }
                                                }}
                                            />
                                        )}
                                    />

                                    {/* <Column
                                        field="amount"
                                        header="Amount"
                                        body={(rowData) => (
                                            <InputText
                                                value={rowData.amount}
                                                // onChange={(e) => onAmountChange(e, rowData)}
                                                onChange={(e) => {
                                                    const inputValue = e.target.value;
                                                    const regex = /^\d+$/;
                                                    if (regex.test(inputValue) || inputValue === "") {
                                                        onAmountChange(inputValue, rowData);
                                                    }
                                                }}
                                            />
                                        )}
                                    /> */}
                                    <Column body={renderAction} header="Action "></Column>
                                </DataTable>
                            </section>
                        )}

                        {showChkGrid && (
                            <section className="DataTable mt-3">
                                <DataTable
                                    value={chequeGridData}
                                    // filterDisplay="row"
                                    // showGridlines
                                    stripedRows
                                    scrollHeight="80vh"
                                    emptyMessage="No Invoice found."
                                    tableStyle={{ minWidth: "60rem" }}
                                >
                                    <Column
                                        field="chequeNo"
                                        header="Cheque/Draft No"
                                        style={{ minWidth: "8rem" }}
                                    ></Column>
                                    <Column
                                        field="chequeDate"
                                        header="Cheque/Draft Date"
                                        style={{ minWidth: "12rem" }}
                                        body={formatChequeDate} // Format the date
                                    ></Column>
                                    <Column
                                        field="drawnOn"
                                        header="Drawn On "
                                        style={{ minWidth: "12rem" }}
                                    ></Column>
                                    <Column
                                        field="paymentAmount"
                                        header="Payment Amount"
                                        style={{ minWidth: "12rem" }}
                                    />
                                    <Column body={renderChequeAction} header="Action "></Column>
                                </DataTable>
                            </section>
                        )}

                        {/* {viewPaymentStatus && (
                    <section className="DataTable">
                        <DataTable
                            value={''}
                            // filterDisplay="row"
                            // showGridlines
                            stripedRows
                            scrollHeight="80vh"
                            emptyMessage="No Invoice found."
                            tableStyle={{ minWidth: "60rem" }}
                        >
                            <Column
                                field="DOCUMENT_NO"
                                header="Document Number 1"
                                style={{ minWidth: "8rem" }}
                            ></Column>
                            <Column
                                field="DOCUMENT_DATE"
                                header="Document Date"
                                style={{ minWidth: "8rem" }}
                            ></Column>
                            <Column
                                field="DOCUMENT_AMOUNT"
                                header="Document Amount "
                                style={{ minWidth: "8rem" }}
                            ></Column>
                            <Column
                                field="AMOUNT"
                                header="Amount"
                                style={{ minWidth: "8rem" }}
                            />
                        </DataTable>
                    </section>
                )} */}
                        <InvoiceesData stateProps={statemodalProps}/>
                    </div>
                    <Dialog
                        header="Confirmation"
                        visible={showPopup}
                        style={{ width: "50vw" }}
                        closable={false}
                        draggable={false}
                        resizable={false}
                    >
                        <div className="p-field">
                            <label htmlFor="rowNo">Row No.</label>
                            <InputText id="rowNo" value={chequeGridData.length + 1} disabled />
                        </div>
                        <div className="p-field">
                            <label htmlFor="chequeNo">Cheque/Draft No.</label>
                            <InputText id="chequeNo" value={chequeNo} onChange={(e) => setChequeNo(e.target.value)} />
                        </div>
                        <div className="p-field">
                            <label htmlFor="drawnOn">Drawn On</label>
                            <Dropdown
                                inputId="BANK_NAME"
                                name="BANK_NAME"
                                value={selectedDrawnOn}
                                options={drawnOn}
                                optionLabel="BANK_NAME"
                                onChange={(e) => {
                                    onDrawnOnChange(e);
                                }}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="chequeDate">Cheque/Draft Date</label>
                            <Calendar
                                id="chequeDate"
                                value={chequeDate || new Date()}
                                onChange={(e) => setChequeDate(e.value)}
                                dateFormat="mm/dd/yy"
                                showIcon
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="paymentAmount">Payment Amount</label>
                            <InputText
                                id="paymentAmount"
                                value={paymentAmount}
                                onChange={(e) => setPaymentAmount(e.target.value)}
                                keyfilter="money"
                            />
                        </div>
                        <div className="float-end">
                            <button
                                type="button"
                                className="btn btn-primary me-3"
                                onClick={handleClickYes}
                            >
                                Yes
                            </button>
                            <button
                                type="button"
                                className="btn btn-cancel-red"
                                onClick={() => setShowPopup(false)}
                            >
                                No
                            </button>
                        </div>
                    </Dialog>
                    {/* Receivable Table record */}
                    {
                        saveLoader ? <Loader /> :
                            <div className="">
                                <Dialog
                                    header="Receivable Records"
                                    visible={adjustedPopup}
                                    style={{ width: "80vw" }}
                                    onHide={() => setAdjustedPopup(false)}
                                    closable={false}
                                    resizable={false}
                                    draggable={false}
                                >
                                    <div className="col-md-12 col-lg-12 col-sm-12">
                                        <div className="DataTable mb-3">
                                            <DataTable
                                                value={documentGridData}
                                                paginator
                                                rows={10}
                                                filterDisplay="row"
                                                // showGridlines
                                                stripedRows
                                                selectionMode="checkbox"
                                                selection={selectedDocumentData}
                                                onSelectionChange={onSelectionChange}
                                                scrollHeight="80vh"
                                                showSelectAll={true}
                                                emptyMessage="No Records found to display"
                                                tableStyle={{ minWidth: "20rem" }}
                                            >
                                                <Column
                                                    selectionMode="multiple"
                                                    header="Select All"
                                                    headerStyle={{ width: "5rem" }}
                                                ></Column>
                                                <Column
                                                    field="DOCUMENT_NO"
                                                    header="Document Number"
                                                    style={{ minWidth: "8rem" }}
                                                    filter
                                                    filterMatchMode="contains"
                                                    filterPlaceholder="Search Here..."
                                                ></Column>
                                                <Column
                                                    field="DOCUMENT_DATE"
                                                    header="Document Date"
                                                    style={{ minWidth: "12rem" }}
                                                    filter
                                                    filterMatchMode="contains"
                                                    filterPlaceholder="Search Here..."
                                                ></Column>
                                                <Column
                                                    field="PAYABLE_AMOUNT"
                                                    header="Outstanding Payables"
                                                    style={{ minWidth: "12rem" }}
                                                    filter
                                                    filterMatchMode="contains"
                                                    filterPlaceholder="Search Here..."
                                                ></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                    <div className="float-end">
                                        <button
                                            type="button"
                                            className="btn btn-primary me-3"
                                            onClick={handleOkReceivable}
                                        >
                                            OK
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-cancel-red"
                                            onClick={() => setAdjustedPopup(false)}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </Dialog>
                            </div>
                    }
                </div>
        }
        </>
    );
};

export default PaymentDetails;